define([], () => {
    return [() => {
        const fingerprintjs = require('@fingerprintjs/fingerprintjs');

        const service = {
            getVisitorId: () => getVisitorId(),
        };

        let visitorId = fingerprintjs
            .load()
            .then((fp) => fp.get())
            .then((result) => result.visitorId);

        function getVisitorId() {
            return visitorId;
        }

        return service;
    }]
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/VisitorIdService.js